module.exports = __webpack_public_path__ + "media/jackpot_winner_4.d4d031b7.mp3";